(function () {'use strict';}());
angular.module("app").directive('contactpreView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/contactpre.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	    $scope.currentSelectionIndex = parseInt(attr.contactpreView);
	  }  
	};
});
